import React from 'react';
import { TableCell, TableHead, TableRow, Table, TableSortLabel } from '@material-ui/core';
const AuditHeader = ({ sortInfo, createSortHandler }) => {
    return (
        <TableHead>
            <TableRow>
                <TableCell>
                    <TableSortLabel
                        active={sortInfo.sort === 'action_type' ? true : false}
                        direction={sortInfo.sort === 'action_type' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('action_type')}
                    >
                        Action Type
                    </TableSortLabel>
                </TableCell>
                <TableCell>
                    <TableSortLabel
                        active={sortInfo.sort === 'created_at' ? true : false}
                        direction={sortInfo.sort === 'created_at' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('created_at')}
                    >
                        Date and Time
                    </TableSortLabel>
                </TableCell>
                <TableCell> Status </TableCell>
                <TableCell> Folder Path </TableCell>
                <TableCell> File Name </TableCell>
                <TableCell> Notification </TableCell>
            </TableRow>
        </TableHead>
    )
}
export default AuditHeader